module.exports = [
  "ENVIRONMENT",
  "GIT_COMMIT",
  "ENABLE_REDUX_DEVTOOLS",
  "ENABLE_SENTRY_REPORTING",
  "PUBLIC_ROOT",
  "FRONTEND_ROOT",
  "BACKEND_ROOT",
  "OAUTH_CLIENT_ID",
  "RAVEN_DSN",
  "DAM_API_URL",
];
